module.exports = __webpack_public_path__ + "static/img/3-1.58c2f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-1.png
// module id = ArrI
// module chunks = 1